import {Flex, Group, Text, useMantineTheme} from '@mantine/core';
import React, {ReactNode} from 'react';

import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {SectionRow} from 'ui-library/reactflow/nodes/BenchlingNode/v2/BenchlingNodeSection';

export interface StandardSectionRowProps {
  /** A ReactFlow handle to display on the left-hand side of this row. */
  leftHandle?: ReactNode;
  /** A ReactFlow handle to display on the right-hand side of this row. */
  rightHandle?: ReactNode;
  /** This text is displayed in small, black text on the left-hand side of the row. */
  primaryText: string;
  /** This text is displayed in small, gray text on the right-hand side of the row. */
  secondaryText?: string;
  /** An icon to be displayed to the left of `primaryText`. */
  icon?: BenchlingIconName;
}

/**
 * A standard section row for a {@link BenchlingNodeV2}.
 * @package
 */
export function StandardSectionRow(props: StandardSectionRowProps): JSX.Element {
  const theme = useMantineTheme();
  const {leftHandle, rightHandle, primaryText, secondaryText, icon} = props;

  return (
    <SectionRow>
      <Flex align="center" justify="space-between" w="100%">
        {leftHandle}

        <Flex align="center" justify="space-between" sx={{flexGrow: 1}}>
          <Group spacing="xs">
            {icon && (
              <BenchlingIcon icon={icon} style={{color: theme.colors.gray[4], height: 11, width: 11}} />
            )}
            <Text size="xs">{primaryText}</Text>
          </Group>
          {secondaryText && (
            <Text c="gray.6" fz="xs">
              {secondaryText}
            </Text>
          )}
        </Flex>
        {rightHandle}
      </Flex>
    </SectionRow>
  );
}
